import './SalesforceButton.scss';

import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import classNames from 'classnames';
import { SalesforceLogo } from '@ui/icons';
import { SonarText } from '@ui/text';
import { useAmplitude } from '@hooks';

import { Button, ButtonProps, Popconfirm, Space } from 'antd';
import { CHANGE_EVENT_PREFERENCES, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';

export interface SalesforceButtonProps extends Omit<ButtonProps, 'onClick'> {
	name: string;
	onClick: () => void
}

export const SalesforceButton: React.FC<SalesforceButtonProps> = ({ className, name, href, onClick, ...rest }) => {
	const log = useAmplitude();

	const handleClick = useCallback(() => {
		log(AMPLITUDE_EVENT.PULSE_OBJECT_CHANGED);
		window.open(href);
		onClick();
	}, [ href, log, onClick ]);

	return (
		<Popconfirm
			cancelText={ COPY_SPECIFIC.NO }
			classNames={ { root: 'manage-objects-popover' } }
			okText={ COPY_SPECIFIC.YES }
			onConfirm={ handleClick }
			placement='bottom'
			title={
				<>
					<p>
						<SonarText className='manage-objects-confirm-message'>
							{ CHANGE_EVENT_PREFERENCES.MANAGE_OBJECTS_CONFIRM_LINE1 }
						</SonarText>
					</p>
					<p>
						<SonarText className='manage-objects-confirm-message'>
							{ CHANGE_EVENT_PREFERENCES.MANAGE_OBJECTS_CONFIRM_LINE2 }
						</SonarText>
					</p>
				</>
			}>
			<Button
				className={ classNames('salesforce-button', className) }
				disabled={ href === '' }
				type='link'
				{ ...rest }>
				<Space
					align='center'
					size='small'>
					<SalesforceLogo />
					{ name }
				</Space>
			</Button>
		</Popconfirm>
	);
};
